import { recordEventCustomOnly } from 'utilities/uTagging';

const EVENT_CATEGORY = 'onboarding/step2/readAndAcceptTheDocuments';

const doTagDataProtectionInformation = ({ document, tag, action, format }) => {
    recordEventCustomOnly({
        eventCategory: EVENT_CATEGORY,
        eventAction: 'dataProtectionInformation',
        eventLabel: tag,
        action,
        format,
        component: 'modal/dataProtectionInformation',
        element: tag,
        documents: document.documentName,
    });
};

export const doTagReadDocumentInfoModal = ({ tag, action, format, element }) => {
    recordEventCustomOnly({
        eventCategory: EVENT_CATEGORY,
        eventAction: 'readDocument',
        eventLabel: tag,
        action,
        format,
        component: 'modal/readDocument',
        element,
    });
};

export const doTagOpenDocumentList = documentToOpen => {
    recordEventCustomOnly({
        eventCategory: EVENT_CATEGORY,
        eventAction: documentToOpen ? 'clickLink' : 'clickButton',
        eventLabel: documentToOpen?.documentType ?? 'readAllDocuments',
        action: 'click',
        format: documentToOpen ? 'link' : 'button',
        component: 'documents',
        element: documentToOpen?.documentType ?? 'readAllDocuments',
        ...(documentToOpen && { documents: documentToOpen.documentName }),
    });
};

export const doTagReOpenDocumentList = documentToOpen => {
    const documentName = documentToOpen?.documentType
        ? `${documentToOpen?.documentType}_reopen`
        : 'readAllPendingDocuments';
    recordEventCustomOnly({
        eventCategory: EVENT_CATEGORY,
        eventAction: documentToOpen ? 'clickLink' : 'clickButton',
        eventLabel: documentName,
        action: 'click',
        format: documentToOpen ? 'link' : 'button',
        component: 'documents',
        element: documentName,
        ...(documentToOpen && { documents: documentToOpen.documentName }),
    });
};

export const doTagShowDocumentsModal = document => {
    recordEventCustomOnly({
        eventCategory: EVENT_CATEGORY,
        eventAction: document.documentType,
        eventLabel: 'open',
        action: 'open',
        format: 'modal',
        component: `modal/${document.documentType}`,
        element: 'full',
        documents: document.documentName,
    });
};

export const doTagDocumentRead = document => {
    doTagDataProtectionInformation({ document, tag: 'readDocument', action: 'read', format: 'document' });
};

export const doTagCancelDocumentsModal = document => {
    doTagDataProtectionInformation({ document, tag: 'return', action: 'return', format: 'link' });
};

export const doTagExitDocumentsModal = document => {
    doTagDataProtectionInformation({ document, tag: 'close', action: 'close', format: 'link' });
};

export const doTagAcceptDocumentAndContinue = document => {
    doTagDataProtectionInformation({ document, tag: 'acceptAndContinue', action: 'click', format: 'button' });
};

export const doTagContinueDocument = document => {
    doTagDataProtectionInformation({ document, tag: 'readNextPendingDoc', action: 'click', format: 'button' });
};

export const doTagConfirmDocument = document => {
    doTagDataProtectionInformation({ document, tag: 'understood', action: 'click', format: 'button' });
};

export const doTagPrintDocument = document => {
    doTagDataProtectionInformation({ document, tag: 'print', action: 'print', format: 'button' });
};

export const doTagDownloadDocument = document => {
    doTagDataProtectionInformation({ document, tag: 'download', action: 'download', format: 'button' });
};

export const doTagClickMifid = () => {
    recordEventCustomOnly({
        eventCategory: EVENT_CATEGORY,
        eventAction: 'clickLink',
        eventLabel: 'mifidLink',

        action: 'click',
        format: 'link',
        component: 'documents',
        element: 'mifidLink',
    });
};
